var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "38px",
    viewBox: "0 0 35 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "water") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "createneworder",
    transform: "translate(-475.000000, -638.000000)",
    fill: "#535353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "samplenumber",
    transform: "translate(152.000000, 539.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "water_card",
    transform: "translate(256.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "water",
    transform: "translate(67.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.75,21.2736136 L29.75,21.2736136 L29.75,14.1827045 C29.75,10.2720682 26.6105,7.09179545 22.75,7.09179545 L15.75,7.09179545 L15.75,3.54634091 L21,3.54634091 L21,0.000886363637 L7,0.000886363637 L7,3.54634091 L12.25,3.54634091 L12.25,7.09179545 L0,7.09179545 L0,14.1827045 L22.75,14.1827045 L22.75,21.2736136 Z",
    id: "Fill-626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5,26.5917955 C24.5,27.5721136 25.28225,28.3645227 26.25,28.3645227 C27.21775,28.3645227 28,27.5721136 28,26.5917955 C28,25.6114773 27.21775,24.8190682 26.25,24.8190682 C25.28225,24.8190682 24.5,25.6114773 24.5,26.5917955",
    id: "Fill-627"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.75,29.2508864 C21.78225,29.2508864 21,30.0432955 21,31.0236136 C21,32.0039318 21.78225,32.7963409 22.75,32.7963409 C23.71775,32.7963409 24.5,32.0039318 24.5,31.0236136 C24.5,30.0432955 23.71775,29.2508864 22.75,29.2508864",
    id: "Fill-628"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.75,29.2508864 C28.78225,29.2508864 28,30.0432955 28,31.0236136 C28,32.0039318 28.78225,32.7963409 29.75,32.7963409 C30.71775,32.7963409 31.5,32.0039318 31.5,31.0236136 C31.5,30.0432955 30.71775,29.2508864 29.75,29.2508864",
    id: "Fill-629"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.25,33.6827045 C25.28225,33.6827045 24.5,34.4751136 24.5,35.4554318 C24.5,36.43575 25.28225,37.2281591 26.25,37.2281591 C27.21775,37.2281591 28,36.43575 28,35.4554318 C28,34.4751136 27.21775,33.6827045 26.25,33.6827045",
    id: "Fill-630"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.25,33.6827045 C18.28225,33.6827045 17.5,34.4751136 17.5,35.4554318 C17.5,36.43575 18.28225,37.2281591 19.25,37.2281591 C20.21775,37.2281591 21,36.43575 21,35.4554318 C21,34.4751136 20.21775,33.6827045 19.25,33.6827045",
    id: "Fill-631"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.25,33.6827045 C32.28225,33.6827045 31.5,34.4751136 31.5,35.4554318 C31.5,36.43575 32.28225,37.2281591 33.25,37.2281591 C34.21775,37.2281591 35,36.43575 35,35.4554318 C35,34.4751136 34.21775,33.6827045 33.25,33.6827045",
    id: "Fill-632"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.71f6a03244c74055c8110f0d8ca6c840.svg";
export { ForwardRef as ReactComponent };